/**
 * Etiquetas de día de la semana compartidas entre el editor de horarios de
 * profesionales (admin) y el portal público de reservas — deben coincidir
 * con `extract(dow from ...)` de Postgres: 0 = domingo … 6 = sábado, igual
 * que `horarios_profesionales.dia_semana` (schema.sql).
 */
export const DIAS_SEMANA = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'] as const;

/**
 * Convierte un valor `<input type="date">` ('YYYY-MM-DD') a un Date en
 * hora LOCAL del navegador, a mediodía... no, a medianoche local — nunca
 * uses `new Date('YYYY-MM-DD')` directo para esto: ese formato lo
 * interpreta como medianoche UTC, y en zonas horarias al oeste de UTC
 * (como America/Bogota) eso cae en el día anterior. Compartido entre el
 * portal público y la agenda del panel — ambos calculan slots
 * disponibles a partir de una fecha elegida en un `<input type="date">`.
 */
export function parseFechaLocal(valor: string): Date {
  const [y, m, d] = valor.split('-').map(Number);
  return new Date(y, m - 1, d);
}
